// VARIOUS CACHE RELATED CODE
/*global _ localStorage vueapp BF*/
import store from "Js/store";

//Register watchers for app model
export const cacheRegListeners = function() {
  _.forEach(store.state.site.content.appCaching, function(c) {
    store.watch((state) => state.site.content.app[c.path], cacheCbGen(c));
  });
}

// Loads cached app data
export const cacheAppLoad = function() {
  _.forEach(vueapp.$store.state.site.content.appCaching, function(c) {
    let app = {};
    try {
      if (c.sessionStorage && c.path in sessionStorage) {
        app[c.path] = JSON.parse(sessionStorage.getItem(c.path));
        vueapp.$store.commit('SET_APP', app);

      }
      else if (c.localStorage && c.path in localStorage) {
        app[c.path] = JSON.parse(localStorage.getItem(c.path));
        vueapp.$store.commit('SET_APP', app);
      }
    }
    catch (error) {
      BF.errorThrow(10170, `Error while loading LS/SS JSON (cacheAppLoad) for "${c.path}":`, { c, error });
    }
  });
};

// cb generator function that is called when a watched app/form key is changed
export const cacheCbGen = function(c) {
  return function(newValue, oldValue) {
    if (c.appSync) {
      vueapp.$store.state.site.content.app[c.path] = newValue
    }
    try {
      c.localStorage ? localStorage.setItem((c.pathPrefix || '') + c.path, JSON.stringify(newValue)) : null;
      c.sessionStorage ? sessionStorage.setItem((c.pathPrefix || '') + c.path, JSON.stringify(newValue)) : null;
    }
    catch (error) {
      BF.errorThrow(10170, `Error while writing LS/SS JSON (cacheCbGen):`, { c, error });
    };
  };
};

// cb generator function, called when a[p sync enabled and app data changes]
export const appSyncCbGen = function(c, state, ind) {
  return function(newValue, oldValue) {
    if (c.appSync) {
      state.windows[ind].formSchema.model[c.path] = newValue
    }
  };
};

// Register watchers for page models
export const cacheFormAdd = function(state, wndw, ind) {
  let prefix = wndw.formSchema.id + '_'; // TODO should be navigational path (slug) of the page
  let modelCaches = wndw.formSchema.modelCaches

  _.forEach(modelCaches, function(c) {
    // Listener for app if appSync
    if (c.appSync) {
      // watch app for changes
      let cb = store.watch(
        (state) => {
          return state.site.content.app[c.path]
        },
        appSyncCbGen(c, state, ind), {
          immediate: true, // returning to a page sync down
          deep: true
        });
      state.windows[ind].cacheRemove.push(cb);
    }

    // for ls, ss, appsync add a model watcher
    if (c.appSync || c.localStorage || c.sessionStorage) {
      c.pathPrefix = prefix
      let cb = store.watch(
        (state) => {
          return state.wndw.windows[ind].formSchema.model[c.path]
        },
        cacheCbGen(c), {
          deep: true
        });

      state.windows[ind].cacheRemove.push(cb);
    }

  });
};

// Getting data from local / session storage
export const cacheFormLoad = function(state, wndw, ind) {
  let prefix = wndw.formSchema.id + '_';
  let caches = wndw.formSchema.modelCaches || [];

  _.forEach(caches, function(c) {
    let model = {};
    let fullpath = prefix + c.path;

    try {
      if (c.sessionStorage && fullpath in sessionStorage) {
        model[c.path] = JSON.parse(sessionStorage.getItem(fullpath));
        Object.assign(state.windows[ind].formSchema.model, model);
      }
      else if (c.localStorage && fullpath in localStorage) {
        model[c.path] = JSON.parse(localStorage.getItem(fullpath));
        Object.assign(state.windows[ind].formSchema.model, model);
      }
    }
    catch (error) {
      BF.errorThrow(10170, `Error while parsing LS/SS JSON for "${c.path}":`, { c, error });
      // TODO throw system error
    }
  });
};

// Remove watchers for page models via callbacks
export const cacheFormRemove = function(state, ind) {
  let cbs = state.windows[ind].cacheRemove
  _.forEach(cbs, function(cb, ind, cbs) {
    cb();
  })
  state.windows[ind].cacheRemove = []
};


// TODO remove
// Returns the cached site if present
export const cacheSiteLoad = function() {

};

// Saves the passed site to cache
export const cacheSiteSave = function(site) {

};
